/**
 * axios实例封装，在这里加上项目对接口请求的统一处理
 */
import axios from "axios";
import config from "@/utils/config";
import { Message } from "element-ui";
// import notification from "ant-design-vue/es/notification";
import router from "@/router";
import imageUrl from "../assets/happy.png";

const { apiHost } = config;

const option = {
  baseURL: apiHost,
  // baseURL: "https://tk-api-dev.bobiton.com",  // 测试
  // baseURL: "https://tk-api-uat.bobiton.com",  // 预发
  // baseURL: "https://mp-dev.bobiton.com",  // 正式
};

// 创建 axios 实例
const service = axios.create(option);

// http request 拦截器
service.interceptors.request.use(
  (config) => {
    if (localStorage.Authorization) {
      config.headers.Authorization = `Bearer ${localStorage.Authorization}`;
    }
    const requestType = config.requestType || "json";
    if (requestType === "upload") {
      config.headers = Object.assign(config.headers || {}, {
        Accept: "*/*",
        "Content-Type": "multipart/form-data",
      });
      const formData = new FormData();
      Object.keys(config.data).forEach((key) => {
        formData.append(key, config.data[key]);
      });
      config.data = formData;
    }
    return config;
  },
  (err) => Promise.reject(err)
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    // 判断处理结果是文件类型时，不对结果集处理，直接返回
    if (response.headers["content-disposition"]) {
      return response;
    }
    // 这里需要根据不同的项目后端接口封装情况做适当调整
    if (res.code === 200) {
      return res;
    } else {
        Message.error( {
            dangerouslyUseHTMLString: true,
                message: `      <div style="height: 100%;display: flex;flex-direction: column;gap: 20px;">
        <div style="margin-left: 20px;">温馨提示</div>
            <div style="width: 320px;
            display: flex;flex-direction: column;
  justify-content: center;
  align-items: center;  gap:20px;"
  >
                <img style="width: 50px;height: 50px;" src="${imageUrl}"/>
                <div >${res.message}</div>
            </div>
      </div>
      `
        })

      // Message.error((res && res.message) || "未知异常！");
      return Promise.reject(new Error((res && res.message) || "未知异常！"));
    }
  },
  (error) => {
    console.log(error.response.data.code)
    // if (!error.response) {
    //   notification.error({
    //     message: "未知异常",
    //     description: "请重试！",
    //   });
    // }

    if (axios.isCancel(error)) {
      console.log("Request canceled");
      return null;
    }
    if (error.response.data.code === 1000) {
      Message.error("登录失效，请重新登录！");
      router.push("/login");
    } else {
        Message.error( {
            dangerouslyUseHTMLString: true,
            message: `      <div style="height: 100%;display: flex;flex-direction: column;gap: 20px;">
        <div style="margin-left: 20px;">温馨提示</div>
            <div style="width: 350px;
            display: flex;flex-direction: column;
  justify-content: center;
  align-items: center;  gap:20px;"
  >
                <img style="width: 50px;height: 50px;" src="${imageUrl}"/>
                <div >${error.response.data.message}</div>
            </div>
      </div>
      `
        })
      // Message.error(error.response.data.message || "未知异常！");
    }
    return Promise.reject(error);
  }
);

export default service;
